// extracted by mini-css-extract-plugin
module.exports = {"TrendingList":"TrendingList_TrendingList__VySxZ","TrendingHeader":"TrendingList_TrendingHeader__353cL"};